<template>
  <div class="d-print-none">
    <v-btn
      v-if="!visible && buttonVisible"
      position="fixed"
      location="bottom right"
      icon="mdi-help-circle-outline"
      class="help-border z-top ma-4"
      :title="$t('helpBarStrings.openButtonTitle')"
      @click="show({contentType: pageContentType, expandedSections: []})"
    />
    <v-navigation-drawer
      v-model="visible"
      location="right"
      width="500"
      temporary
    >
      <v-card flat>
        <v-btn
          :size="buttonSize"
          class="help-border"
          position="fixed"
          location="top right"
          icon="mdi-close"
          :title="$t('helpBarStrings.closeButtonTitle')"
          @click="hide()"
        />
        <v-card-title class="py-0">
          <h2 class="text-h2 mt-10 mb-7">
            {{ $t('helpBarStrings.title') }}
          </h2>
        </v-card-title>
        <v-card-subtitle>
          <h2 class="text-h2 mt-10 mb-7">
            {{ $t(`enums.helpBarContentTypes.${contentType}`) }}
          </h2>
        </v-card-subtitle>
        <v-card-text>
          <help-content />
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import HelpBarContentTypes from "@/enums/HelpBarContentTypes";
import HelpContent from "./components/HelpContent";
import { useDisplay } from 'vuetify';

export default {
  name: "HelpBar",
  components: {
    HelpContent
  },
  setup() {
    const { xs, smAndUp } = useDisplay();
    return { xs, smAndUp };
  },
  methods: {
    ...mapMutations({
      show: "helpBarStore/show",
      hide: "helpBarStore/hide"
    })
  },
  computed: {
    ...mapGetters({
      visibleSetting: "helpBarStore/visible",
      contentType: "helpBarStore/contentType",
      expandedSections: "helpBarStore/expandedSections"
    }),
    buttonSize() {
      if (this.xs)
        return 'x-small';

      if (this.smAndUp)
        return 'small';

      return undefined;
    },
    pageContentType(){
        switch (this.$route.name) {
        case "createApplication":
          return HelpBarContentTypes.Application;
        case "orgApplications":
          return HelpBarContentTypes.OrgApplications;
        case "orgApplicationDetails":
          return HelpBarContentTypes.ApplicationPreview;
        case "backoffice":
          return HelpBarContentTypes.OrgSettings;
        case "applications":
          return HelpBarContentTypes.Applications;
        default:
          return HelpBarContentTypes.None;
      }
    },
    visible: {
      get() {
        return this.visibleSetting;
      },
      set(value) {
        if (!value) {
          this.hide();
        }
      }
    },
    buttonVisible() {
      return this.pageContentType !== HelpBarContentTypes.None;
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-position-middle {
  top: 40%;
}

.z-top {
  z-index: 10;
}

.help-border {
  border: 2px solid var(--v-warning-base);
}
</style>
